const provinces = [
	{
		code: 'EC',
		name: 'Eastern Cape'
	},
	{
		code: 'FS',
		name: 'Free State'
	},
	{
		code: 'GP',
		name: 'Gauteng'
	},
	{
		code: 'KZN',
		name: 'KwaZulu-Natal'
	},
	{
		code: 'LP',
		name: 'Limpopo'
	},
	{
		code: 'MP',
		name: 'Mpumalanga'
	},
	{
		code: 'NC',
		name: 'Northern Cape'
	},
	{
		code: 'NW',
		name: 'North West'
	},
	{
		code: 'WC',
		name: 'Western Cape'
	}
];

export { provinces };
